import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { BadgeColor } from '../badge-single-color/model';
import { StarsWidgetConfig } from './model';
import { resolveWidgetColor } from '../../helpers/widget-color.helper';

@Component({
  selector: 'app-stars-widget',
  standalone: true,
  imports: [CommonModule, MatIconModule, MatTooltipModule],
  templateUrl: './stars-widget.component.html',
  styleUrl: './stars-widget.component.scss',
})
export class StarsWidgetComponent {
  private _value: number = 0;
  private _max: number = 100;

  @Input()
  set value(val: number) {
    this._value = val;
    this.calculateStars();
  }
  get value(): number {
    return this._value;
  }

  @Input()
  set max(val: number) {
    this._max = val;
    this.calculateStars();
  }
  get max(): number {
    return this._max;
  }

  @Input() tooltip?: string | ((value: number, max: number) => string);
  @Input() color?: BadgeColor;
  @Input() customColor?: string;
  @Input() action?: (value: any) => void; // Optional action callback
  @Input() translationPrefix?: string; // Translation prefix from grid (read-only)

  stars: Array<'full' | 'half' | 'empty'> = [];

  ngOnInit(): void {
    this.calculateStars();
  }

  private calculateStars(): void {
    // Calculate percentage: (value / max) * 100, then convert to 0-5 scale
    const percentage = Math.min(
      Math.max((this._value / this._max) * 100, 0),
      100,
    );
    const starCount = (percentage / 100) * 5;

    this.stars = [];
    for (let i = 0; i < 5; i++) {
      if (starCount >= i + 1) {
        this.stars.push('full');
      } else if (starCount > i && starCount < i + 1) {
        this.stars.push('half');
      } else {
        this.stars.push('empty');
      }
    }
  }

  getTooltip(): string {
    if (typeof this.tooltip === 'function') {
      return this.tooltip(this._value, this._max);
    }
    // If tooltip is a string, return it as-is
    if (this.tooltip) {
      return this.tooltip;
    }
    // Default tooltip if none provided
    const percentage = Math.round((this._value / this._max) * 100);
    return `${this._value}/${this._max} = ${percentage}%`;
  }

  getStarColor(): string {
    return resolveWidgetColor({
      customColor: this.customColor,
      color: this.color,
    });
  }

  onClick(event: MouseEvent): void {
    if (this.action) {
      event.preventDefault();
      event.stopPropagation();
      this.action(this.value);
    }
  }
}
